import { ReactNode } from 'react';

import { Cyclone } from '@mui/icons-material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import BrightnessLowTwoToneIcon from '@mui/icons-material/BrightnessLowTwoTone';
import DescriptionSharpIcon from '@mui/icons-material/DescriptionSharp';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import PersonIcon from '@mui/icons-material/Person';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PrintIcon from '@mui/icons-material/Print';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import Diversity1Icon from '@mui/icons-material/Diversity1';

export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  items?: MenuItem[];
  name: string;
}

export interface MenuItems {
  items: MenuItem[];
  heading: string;
}

export const getMenuItems = (user): MenuItems[] => {
  const adminItem: MenuItem[] = [
    {
      name: 'Clients',
      icon: PersonOutlineOutlinedIcon,
      link: '/management/clients'
    },
    {
      name: 'Add Users',
      icon: SupervisedUserCircleIcon,
      link: '/management/addApplicationUser'
    },
    {
      name: 'New Quote',
      icon: FormatQuoteIcon,
      link: '/management/newQuote'
    },
    {
      name: 'New Teacher Form',
      icon: PersonIcon,
      link: '/management/new-teacher-form'
    },
        {
      name: 'All Agreements Table',
      icon: Diversity1Icon,
      link: '/management/all-agreements-table'
    }
  ];

  const clientItem: MenuItem[] = [];

  if (!user?.username) {
    clientItem.push({
      name: 'Recent Scorm Connectors',
      icon: CloudDownloadIcon,
      link: '/management/recent-scorm'
    });
  }

  return [
    ...(user?.role === 'billing_admin'
      ? [
          {
            heading: 'Dashboards',
            items: [
              {
                name: 'Dashboard',
                link: '/dashboards/crypto',
                icon: BrightnessLowTwoToneIcon
              }
            ]
          }
        ]
      : []),

    ...(user?.role === 'billing_admin'
      ? [
          {
            heading: 'Management',
            items: adminItem
          }
        ]
      : []),

    {
      heading: user?.role !== 'billing_admin' ? '' : 'Retool Apps',
      items:
        user?.role !== 'billing_admin'
          ? []
          : [
              {
                name: 'Admin App',
                link: '/dashboards/admin_app',
                icon: AdminPanelSettingsIcon
              },
              {
                name: 'Production App',
                link: '/dashboards/production_app',
                icon: PrintIcon
              },
              {
                name: 'Scormify Reporting App',
                link: '/dashboards/scormify_logs_app_loader',
                icon: Cyclone
              },
              {
                name: 'Documentation',
                link: '/dashboards/documentation_app',
                icon: DescriptionSharpIcon
              }
            ]
    }
  ];
};
